<BolideLoader v-show="is_loading" />
<div class="dashboard-container container-fluid px-0" v-show="!is_loading">
    <div class="row g-0 vh-100 overflow-visible">
        <!-- ======= SIDEBAR AREA (DESKTOP ONLY) ======= -->
        <div v-if="!is_mobile" class="col-auto sidebar-wrapper sidebar-offset
                    d-flex flex-column flex-shrink-0
                    position-sticky
                    vh-100
                    overflow-hidden
                    overflow-x-visible" :class="{ 'sidebar-collapsed': sidebar_collapsed }">

            <PortfolioSidebar :active_item="active_menu_item" @global-menu-selected="handleGlobalMenuSelected"
                @global-selected="goBack" />

        </div>
        <!-- ======= MOBILE SIDEBAR OVERLAY ======= -->
        <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="close_sidebar">
            <div class="mobile-sidebar-panel">

                <!-- ===== PORTFOLIO MODE ===== -->
                <PortfolioSidebar :active_item="active_menu_item" @global-menu-selected="handleGlobalMenuSelected"
                    @global-selected="goBack" @close-sidebar="close_sidebar">
                    <template #sidebar-header-actions>
                        <button class="sidebar-close-btn" @click="close_sidebar" aria-label="Close sidebar">
                            <i class="bi bi-x-lg"></i>
                        </button>
                    </template>
                </PortfolioSidebar>

            </div>
        </div>
        <button v-if="!is_mobile" type="button"
            class="sidebar-collapse-btn btn btn-sm d-inline-flex align-items-center justify-content-center p-0"
            :aria-label="sidebar_collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
            :title="sidebar_collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
            :aria-expanded="!sidebar_collapsed"
            @click="toggleSidebar">
            <i class="bi" :class="sidebar_collapsed ? 'bi-chevron-right' : 'bi-chevron-left'" aria-hidden="true"></i>
        </button>

        <!-- ======= MAIN CONTENT AREA ======= -->
        <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
            <HeaderSection :breadcrumb="breadcrumb" @breadcrumb-click="handleBreadcrumbClick"
                @open-assistant="showAssistant = true" @toggle-mobile-sidebar="toggle_mobile_sidebar" />

            <BolideAssistant :is_open="showAssistant" @close-assistant="showAssistant = false" />

            <main class="dashboard-main flex-grow-1 h-100">
                <div class="dashboard-main-view w-100 h-100">
                    <div class="row g-0 h-100">
                        <PortfolioSuperSetChart :content_class="getMainContentClass()" chart_id="dashboard-main"
                            :iframe_loading="iframeLoading" />
                    </div>
                </div>

            </main>
        </div>

    </div>
</div>
